jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $("body").on("keydown", function () {
        if (!$(".keyboard-in-use")[0]) {
            $(this).addClass("keyboard-in-use");
        }
    });

    $("body").on("mousedown", function () {
        if ($(".keyboard-in-use")[0]) {
            $(this).removeClass("keyboard-in-use");
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Remove Body Style
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $(window).on('load resize', function () {
        if (($('body').css('overflow', 'hidden') && !$('.o-header--open')[0]) || $(window).width() >= 1200) {
            $('body').removeAttr('style');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser: Animate Scroll to Anchor Link
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href="#content"]').click(function (e) {
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                e.preventDefault();

                const targetTop = target.offset().top - 50;

                $('html, body').animate({
                    scrollTop: targetTop > 0 ? targetTop : 0
                }, 600);
            }
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Header On Scroll
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    var lastScrollTop = 0;

    $(window).on("scroll load", function () {
        if (!$('.o-notification-bar')[0]) {
            var windowTop = $(this).scrollTop();

            if (windowTop < lastScrollTop) {
                $(".o-header").addClass("o-header--scroll-up");
            } else {
                $(".o-header").removeClass("o-header--scroll-up");
            }

            lastScrollTop = windowTop;

            if (windowTop > 75) {
                $(".o-header").addClass("o-header--scroll");
            } else {
                $(".o-header").removeClass("o-header--scroll");
                $(".o-header").removeClass("o-header--scroll-up");
            }
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ FeaturedTeamMemberCardsSlider
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    // if ($('.o-featured-team-member-cards-slider')[0]) {
    // var slides     = $('.o-featured-team-member-cards-slider .m-thumbnail-bio-cards--slider .m-thumbnail-bio-cards__list'),
    //     slide      = $('.m-thumbnail-bio-cards--slider .m-thumbnail-bio-cards__item'),
    //     lastSlide  = slide.last(),
    //     firstSlide = slide.first(),
    //     prevButton = $('.prev'),
    //     nextButton = $('.next'),
    //     dotsNavigation = $('.o-featured-team-member-cards-slider .m-dots-navigation'),
    //     dotsNavigationItem = dotsNavigation.find('.m-dots-navigation__item');

    // prevButton.click(function() {
    //     var activeSlide = slides.find('.m-thumbnail-bio-cards__item--active'),
    //         prevSlide   = activeSlide.prev();

    //     if (!firstSlide.hasClass('m-thumbnail-bio-cards__item--active')) {
    //         slides.removeClass('start');
    //         activeSlide.removeClass('m-thumbnail-bio-cards__item--active');
    //         dotsNavigationItem.removeClass('m-dots-navigation__item--active');
    //         prevSlide.removeClass('hide');

    //         prevSlide.addClass('m-thumbnail-bio-cards__item--active');
    //         dotsNavigationItem.eq(prevSlide.index()).addClass('m-dots-navigation__item--active');
    //     }

    //     if (firstSlide.hasClass('m-thumbnail-bio-cards__item--active')) {
    //         slides.addClass('start');
    //     }
    // });

    // nextButton.click(function() {
    //     var activeSlide = slides.find('.m-thumbnail-bio-cards__item--active'),
    //         nextSlide   = activeSlide.next();

    //     if (!lastSlide.hasClass('m-thumbnail-bio-cards__item--active')) {
    //         slides.removeClass('end');
    //         activeSlide.removeClass('m-thumbnail-bio-cards__item--active');

    //         activeSlide.addClass('hide');
    //         nextSlide.addClass('m-thumbnail-bio-cards__item--active');
    //     }

    //     dotsNavigationItem.removeClass('m-dots-navigation__item--active');

    //     dotsNavigationItem.eq(nextSlide.index()).addClass('m-dots-navigation__item--active');

    //     if (lastSlide.hasClass('m-thumbnail-bio-cards__item--active')){
    //         slides.addClass('end');
    //     }
    // });

    // dotsNavigationItem.click(function() {
    //     var slideIndex  = $(this).data('slide');

    //     dotsNavigationItem.removeClass('m-dots-navigation__item--active');

    //     if (slideIndex == '0') {
    //         slide.eq('0').removeClass('hide');
    //         slide.eq('1').removeClass('hide');
    //     } else if (slideIndex == '1') {
    //         slide.eq('1').removeClass('hide');
    //     } else if (slideIndex == '2') {
    //         slide.eq('0').addClass('hide');
    //         slide.eq('1').addClass('hide');
    //     }

    //     slide.removeClass('m-thumbnail-bio-cards__item--active');

    //     $(this).addClass('m-dots-navigation__item--active');

    //     slide.eq(slideIndex).addClass('m-thumbnail-bio-cards__item--active');

    //     if (lastSlide.hasClass('m-thumbnail-bio-cards__item--active')) {
    //         slides.addClass('end');
    //     }
    // });
    // }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Back to Top
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function scrollTopAnimated(element, top) {
        element.animate({
            scrollTop: top
        });
    }

    if ($('.p-location-archive .js-back-to-top')[0]) {
        var content = $('.p-location-archive__content');

        $('.p-location-archive .js-back-to-top').click(function () {
            scrollTopAnimated(content, '-20');
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Header
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟MenuToggle
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    $('.o-header__hamburger').click(function () {
        if ($('.o-header--open')[0]) {
            $('body').removeAttr('style');
        } else {
            $('body').css('overflow', 'hidden');
        }

        $(this).toggleClass('a-hamburger--toggled');
        $('.o-header').toggleClass('o-header--open');
        $('.o-header__navigation-inner').toggleClass('o-header__navigation-inner--open');
    });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Accessibility
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    if ($('.o-header__hamburger')[0]) {
        // On Toggle Keydown
        $('.o-header__hamburger').keydown(function (e) {

            if (e.key === 'Enter') {
                e.preventDefault();

                $('.o-header__wrapper').toggleClass('o-header__wrapper--open');

                if ($('.o-header__wrapper').hasClass('o-header__wrapper--open')) {
                    $('.o-header .m-page-nav__list').attr('aria-expanded', 'true');
                    $(this).attr('aria-pressed', 'true');
                    $(this).addClass('a-hamburger--toggled');
                    $('body').css('overflow', 'hidden');

                } else {
                    $('.o-header .m-page-nav__list').attr('aria-expanded', 'false');
                    $(this).attr('aria-pressed', 'false');
                    $(this).removeClass('a-hamburger--toggled');
                    $('body').removeAttr('style');
                }

                setTimeout(function () {
                    list.find("li:first-child a").focus();
                }, 0);
            }
        });
    }
});